import DefaultCssSelectors from "../constants/DefaultCssSelectors"

/** Get class names to which we insert/append widgets to */
const getWidgetSelectors = (
  customSelectors?: Record<string, string | undefined>
) => {
  // Filter out falsy class names, class names that are empty strings etc. from the object
  const newSelectors =
    customSelectors &&
    Object.keys(customSelectors)
      .filter((k) => customSelectors[k])
      .reduce((a, k) => ({ ...a, [k]: customSelectors[k] }), {})

  return { ...DefaultCssSelectors, ...newSelectors }
}

export default getWidgetSelectors
